module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/season/image-4af57efa5d26c72d415f4140b28fd1cd.png";